import { Button } from "@mozioinc/ui";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as TimerSvg } from "./assets/timer.svg";

export const useCounter = (onCounterEnd?: () => void) => {
  const COUNTDOWN_SECONDS = 60;
  const [counter, setCounter] = useState(0);

  const startCounter = () => {
    setCounter(COUNTDOWN_SECONDS);
  };

  useEffect(() => {
    let timer: number;
    if (counter > 0) {
      timer = setTimeout(() => setCounter(counter - 1), 1000);
    } else if (counter === 0) {
      if (onCounterEnd) {
        onCounterEnd();
      }
      setCounter(0);
    }
    return () => clearTimeout(timer);
  }, [counter, onCounterEnd]);

  return { counter, startCounter };
};

interface ResendConfirmationButtonProps {
  countdown: number;
  onButtonClick: () => void;
}

const ResendConfirmationButton: React.FC<ResendConfirmationButtonProps> = ({
  countdown,
  onButtonClick,
}) => {
  const { t } = useTranslation("parking:purchase-summary");

  const handleClick = () => {
    onButtonClick();
  };

  return (
    <div>
      <div className="flex h-5 items-center gap-5 text-xs text-neutral-800">
        {countdown === 0 && (
          <Button
            variant={"ghost"}
            onClick={handleClick}
            className="p-0 text-xs"
          >
            {t("Resend confirmation")}
          </Button>
        )}

        {countdown > 0 && (
          <>
            <span>{t("Resend confirmation")}</span>
            <div className="flex items-center gap-1">
              <TimerSvg className="text-xl" />{" "}
              {t("in {{countdown}} sec", { countdown })}.
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export { ResendConfirmationButton };
